/*
 | Palabra rotativa del titular del hero. La lista se puede pasar por
 | x-data="rotator(['WordPress', 'Joomla'])"; por defecto usa las apps más comunes.
 */
export default function rotator(words = ["WordPress", "WooCommerce", "Joomla", "Drupal", "PrestaShop", "Laravel", "Magento", "Nextcloud", "Moodle"]) {
    return {
        words,
        index: 0,
        word: words[0],
        out: false,
        init() {
            if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
            setInterval(() => {
                this.out = true;
                setTimeout(() => {
                    this.index = (this.index + 1) % this.words.length;
                    this.word = this.words[this.index];
                    this.out = false;
                }, 400);
            }, 2800);
        },
    };
}
